<template>
  <span class="practice-doc" v-if="data">
    <lr-link :to="data.url" :target="target" class="practice-doc-btn">
      <icon type="iconic_download1"></icon>
      <span>练习文档</span>
    </lr-link>

    <lr-link :to="data.url" :target="target" class="practice-doc-exercise">
      <span>{{ data.name }}</span>
      <span>{{ data.size }}</span>
    </lr-link>
  </span>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  computed: {
    target() {
      const type = (this.data && this.data.name.split('.').slice(-1)[0]) || '';
      return type && type !== 'pdf' ? '_self' : '_blank';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.practice-doc {
  position: relative;
  &-btn {
    @include btn-style();
    cursor: pointer;
      &:hover {
        color: #222226;
      }
  }

  &:hover {
    .practice-doc-exercise {
      display: flex;
    }
  }

  &-exercise {
    z-index: 1;
    display: none;
    justify-content: space-between;
    align-items: center;
    padding: 0px 15px;
    line-height: 48px;
    height: 48px;
    position: absolute;
    bottom: -48px;
    left: -10px;
    width: 263px;
    text-align: center;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.16);
    border-radius: 4px;

    span {
      color: #999999;

      &:first-child {
        display: inline-block;
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #417ff9;
        text-decoration: underline;
      }
    }
  }
}
</style>
